import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { getCasesByPetitionerLawfirmPerformance, getCasesByPatentOwnerLawfirmPerformance } from "../../../../services/api-ptab";
import LoadingWrapper from "../../../common/loading-wrapper";
import { sortBy } from "lodash";
import { Table } from "antd";
import { sorterNumberGen, sorterStringGen } from "../../../../helpers/table";
import { toItemPTABSearchLink } from "../../../../helpers/converters";
import { withTableConfig } from "../../../common/table-config-hoc";

const TopLawfirms = ({ type, query, style = {} }) => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: false
  });

  const _getLawfirms = () => {
    const apiCall = type === "p" ? getCasesByPetitionerLawfirmPerformance(query) : getCasesByPatentOwnerLawfirmPerformance(query);
    apiCall
      .then(res => {
        const scorer = l => {
          const numInst = res[l]["Instituted - Granted"] || 0;
          const numNotInstM = res[l]["Not Instituted - Merits"] || 0;
          const numFWDP = res[l]["All Claims Patentable"] || 0;
          return (numInst - numNotInstM - 2 * numFWDP) / (numInst + numNotInstM);
        };
        const denom = l => {
          const numInst = res[l]["Instituted - Granted"] || 0;
          const numNotInstM = res[l]["Not Instituted - Merits"] || 0;
          return numInst + numNotInstM;
        };
        setState({
          data: sortBy(
            Object.keys(res).map(l => ({
                name: l,
                isix: scorer(l),
                numDenom: denom(l) // denominator for ISIX score, count of 'Decisions on the Merits'
              })),
              e => (type === "p" ? -e.isix : e.isix)
            ).map((r, i) => ({
              ...r,
              rank: i + 1
            })), // default sort for scores
          loading: false
        });
      })
      .catch(() => {
        setState({
          loading: false,
          error: true
        });
      });
  };

  useEffect(() => {
    _getLawfirms();
  }, [type, query]);

  const columns = [
    {
      dataIndex: "name",
      title: "Law Firm",
      sorter: sorterStringGen("name"),
      render: l => [l, toItemPTABSearchLink(l, null, type === "p" ? "lawfirms.petitioner" : "lawfirms.patent_owner")]
    },
    {
      dataIndex: "numDenom",
      title: "Decisions on the Merits",
      sorter: sorterNumberGen("numDenom")
    },
    {
      dataIndex: "isix",
      title: "ISIX",
      sorter: sorterNumberGen("isix"),
      render: score => score.toFixed(2)
    },
    {
      dataIndex: "rank",
      title: "Rank"
    }
  ];

  const WrappedTable = withTableConfig(Table, { dataSource: state.data });

  return (
    <LoadingWrapper loading={state.loading} error={state.error} style={style}>
      <WrappedTable dataSource={state.data} columns={columns} rowKey={"name"} pagination={false} size="small" />
    </LoadingWrapper>
  );
}

TopLawfirms.propTypes = {
  type: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  style: PropTypes.object
};

export default withRouter(TopLawfirms);
